import { Button, Grid, Typography } from "@mui/material";
import "../AppDesktop.css";
import ButtonCeci from "./ButtonCeci";

export default function Card2() {
    return (
        <Grid container size={12} sx={{width: '100%'}}>
            <Grid item size={1.5}/>
            <Grid item size={3.5} sx={{textAlign: 'left'}}>                
                <div style={{marginTop: '50vh'}} className="stile-titolo bianco">JASMINE PASQUA</div>
                <div style={{marginTop: '50px'}}className="stile-sottotitolo bianco">sono una chinesiologa laureata in scienze delle attività motorie e sportive e specializzata nella ginnastica posturale</div>
            </Grid>
        </Grid>
    );
}
